export default __webpack_public_path__ + "static/media/next-page-arrow.fbb132fc.svg";